module.exports = __webpack_public_path__ + "img/soft_14.f3e98514.png";